import { FC } from "react"
import './sellerdashcard.css'
import {  FaArchive } from "react-icons/fa";
import {  HiOutlineLink } from "react-icons/hi";
import { MdOutlineAttachMoney  } from "react-icons/md";
import { floatToPrice } from "../../functions/price_functions";
type SellerDashCard = {
  value: string
  name: string
  type: string
}

const SellerDashCard: FC<SellerDashCard> = ({ value, name, type }) => {

  function formatNumber() {
    let newValue = value

    if (type === 'money') {
      newValue = floatToPrice(parseFloat(value))
    }
    return newValue
  }

  function selectIcon() {
    switch (name.toLowerCase()) {
      case 'clicks':
        return <HiOutlineLink size={18} fontWeight={'normal'} color="#6E7586"/>
      case 'vendas':
        return <div style={{marginRight:'-6px'}}>
          <MdOutlineAttachMoney  size={23} fontWeight={'normal'}color="#6E7586" />
        </div>
      default:
        return <FaArchive size={18} fontWeight={'normal'} color="#6E7586"/>
    }
  }

  return (
    <div className="card">
      <span className="value">{formatNumber()}</span>
      <div className="infoCard">
        {selectIcon()}
        <span className="name">{name}</span>
      </div>
    </div>
  )
}

export { SellerDashCard }